import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "card w-full mtop-10 pad-l" }
const _hoisted_4 = { class: "row w-full" }
const _hoisted_5 = ["src"]

import { AdminApi, CreateUpdateInstituteRequest, InstituteLightResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag';
import { FilterMatchMode } from '@primevue/core/api';
import SharedService from "@/services/SharedService";
import EsInstituteForm from "@/components/form/admin/esInstituteForm.vue";
import EsManageAdmin from "@/components/modals/admin/esManageAdmin.vue";
import { ApiError, SctLanguageItem } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAdminInstitute',
  setup(__props) {

const {t} = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);

const instituteList = ref<InstituteLightResponse[]>([]);
const loading = ref(true);
const dataTableColumns = [
    { field: 'name', header: t('admin.institute.table.name') },
    { field: 'instituteRole', header: t('admin.institute.table.instituteRole') },
    { field: 'active', header: t('admin.institute.table.active') },
    { field: 'admin', header: t('admin.institute.table.admin') },
    { field: 'update', header: t('admin.institute.table.update') }
];
const selectedInstitute = ref<InstituteLightResponse>();
const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const openInstituteModal = ref<boolean>(false);
const openAdminPersonModal = ref<boolean>(false);
const headerForm = ref<string>(t('admin.institute.label.add.header'));

const getAllInstitutes = () => {
    adminApi.searchInstitute({type: null}).then((response: InstituteLightResponse[]) => {
        instituteList.value = response.sort((a, b) =>
            a.name.localeCompare(b.name, SctLanguageItem.FrFr, { sensitivity: 'base' })
        );
        loading.value = false;
    }).catch(() => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t('error.DEFAULT')
        });
    });
}

const openManageAdminModal = (institute: InstituteLightResponse) => {
    selectedInstitute.value = institute;
    openAdminPersonModal.value = true;
}

const openAddForm = () => {
    openInstituteModal.value = true;
    headerForm.value = t('admin.institute.label.add.header');

}

const closeAdminPersonModal = () => {
    openAdminPersonModal.value = false;
    selectedInstitute.value = undefined;
    getAllInstitutes();
}

const setDataAfterCloseFormModal = () => {
    openInstituteModal.value = false;
    selectedInstitute.value = undefined;
}

const closeFormModal = async (createUpdateInstituteRequest: CreateUpdateInstituteRequest) => {
    if (createUpdateInstituteRequest) {
        if (createUpdateInstituteRequest.instituteId) {
            await updateInstitute(createUpdateInstituteRequest);
        } else {
            await addInstitute(createUpdateInstituteRequest);
        }
    } else {
        setDataAfterCloseFormModal();
    }
}

const addInstitute = async (createUpdateInstituteRequest: CreateUpdateInstituteRequest) => {
    await adminApi.addInstitute({createUpdateInstituteRequest: createUpdateInstituteRequest})
        .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.add'),
                detail:  t('admin.institute.label.add.message.success')
            });
            getAllInstitutes();
            setDataAfterCloseFormModal();
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
            // Throw error to set at false the var __alreadyClicked in v-one-click directive
            throw error;
        });
}

const updateInstitute = async (createUpdateInstituteRequest: CreateUpdateInstituteRequest) => {
    await adminApi.adminUpdateInstitute({instituteId: createUpdateInstituteRequest.instituteId, createUpdateInstituteRequest: createUpdateInstituteRequest})
        .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.update'),
                detail:  t('admin.institute.label.update.message.success')
            });
            getAllInstitutes();
            setDataAfterCloseFormModal();
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
            // Throw error to set at false the var __alreadyClicked in v-one-click directive
            throw error;
        });
}

const clearFilter = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
};

const openInstituteUpdate = async (institute: InstituteLightResponse) => {
    selectedInstitute.value = institute
    headerForm.value = t('admin.institute.label.update.header');
    openInstituteModal.value = true;
}

watch(
  () => selectedInstitute.value,
  async () => {
    if (selectedInstitute.value && !openAdminPersonModal.value) {
        headerForm.value = t('admin.institute.label.update.header');
        openInstituteModal.value = true;
    } else {
        openInstituteModal.value = false;
    }    
  }
);

onMounted(async () => {
    await getAllInstitutes();
});


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('admin.subMenu.institute')), 1),
      _createVNode(_component_es_button, {
        label: _unref(t)('action.add'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddForm())),
        "is-primary": true
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        filters: filters.value,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
        dataKey: "id",
        globalFilterFields: ['name', 'instituteRole'],
        loading: loading.value,
        value: instituteList.value,
        stripedRows: "",
        paginator: "",
        rows: 10,
        rowsPerPageOptions: [5, 10, 20, 50],
        class: "w-full"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                      class: "img-grey"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(InputText), {
                  modelValue: filters.value['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                  placeholder: _unref(t)('admin.institute.search')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_es_button_icon, {
                      icon: "xmark",
                      folder: "shareIcons",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                      styles: "img-grey"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('admin.institute.table.empty')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataTableColumns, (col) => {
            return _createElementVNode("div", {
              key: col.field
            }, [
              (col.field !== 'active' && col.field !== 'admin' && col.field !== 'update')
                ? (_openBlock(), _createBlock(_unref(Column), {
                    key: col.field,
                    field: col.field,
                    header: col.header,
                    sortable: ""
                  }, null, 8, ["field", "header"]))
                : _createCommentVNode("", true)
            ])
          }), 64)),
          _createVNode(_unref(Column), {
            field: 'active',
            header: _unref(t)('admin.institute.table.active')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Tag), {
                severity: slotProps.data.active ? 'success' : 'warn',
                value: slotProps.data.active ? _unref(t)('common.status.active') : _unref(t)('common.status.unactive')
              }, null, 8, ["severity", "value"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'admin',
            header: _unref(t)('admin.institute.table.admin')
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.admin && slotProps.data.admin.length > 0)
                ? (_openBlock(), _createBlock(_component_es_button_icon, {
                    key: 0,
                    icon: "person-checkmark_fill",
                    folder: "shareIcons",
                    class: "pad-l",
                    styles: "img-primary",
                    onClick: ($event: any) => (openManageAdminModal(slotProps.data))
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_es_button_icon, {
                    key: 1,
                    icon: "person",
                    folder: "shareIcons",
                    class: "pad-l",
                    styles: "img-grey",
                    onClick: ($event: any) => (openManageAdminModal(slotProps.data))
                  }, null, 8, ["onClick"]))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'update',
            header: _unref(t)('admin.institute.table.update')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_es_button_icon, {
                icon: "pencil_fill",
                folder: "shareIcons",
                class: "pad-l",
                styles: "img-primary",
                onClick: ($event: any) => (openInstituteUpdate(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["filters", "loading", "value"])
    ]),
    _createVNode(EsInstituteForm, {
      isOpen: openInstituteModal.value,
      header: headerForm.value,
      "current-institute": selectedInstitute.value,
      "confirm-method": closeFormModal,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (setDataAfterCloseFormModal()))
    }, null, 8, ["isOpen", "header", "current-institute"]),
    _createVNode(EsManageAdmin, {
      isOpen: openAdminPersonModal.value,
      header: headerForm.value,
      "current-institute": selectedInstitute.value,
      onModalClose: _cache[5] || (_cache[5] = ($event: any) => (closeAdminPersonModal()))
    }, null, 8, ["isOpen", "header", "current-institute"])
  ], 64))
}
}

})